<template>
	<v-col class="summary-bonus">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Summary Komisi</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-database</v-icon>
			<div class="pl-2">Komisi</div>
			<div class="px-2">/</div>
			<div>Summary Komisi</div>
		</div>

		<div class="mt-5">
			<div v-if="loading">
				<v-row justify="center">
					<v-col cols="12" sm="4" md="3" xl="2" class="pb-0 pb-sm-3" v-for="i in 3" :key="i">
						<v-card class="elevation-0 rounded-lg">
							<vcl :width='300' :height='100'>
								<rect x="30" y="35" rx="20" ry="20" width="40" height="40" />
								<rect x="90" y="30" rx="2" ry="2" width="110" height="25" />
								<rect x="90" y="65" rx="2" ry="2" width="150" height="20" />
							</vcl>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="5" md="4">
						<v-card class="elevation-0 rounded-lg">
							<vcl :width='300' :height='380'>
								<rect x="15" y="20" rx="20" ry="20" width="40" height="40" />
								<rect x="75" y="20" rx="2" ry="2" width="90" height="18" />
								<rect x="75" y="46" rx="2" ry="2" width="130" height="14" />
								<rect x="15" y="85" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="108" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="145" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="168" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="205" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="228" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="265" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="288" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="325" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="348" rx="2" ry="2" width="120" height="18" />
							</vcl>
						</v-card>
					</v-col>
					<v-col cols="12" sm="7" md="8" class="pt-0">
						<v-card class="elevation-0 rounded-lg mt-3" v-for="i in 5" :key="i">
							<vcl :height='40'>
								<rect x="10" y="18" rx="2" ry="2" width="55" height="10" />
								<rect x="105" y="11" rx="2" ry="2" width="45" height="8" />
								<rect x="105" y="24" rx="2" ry="2" width="65" height="10" />
								<rect x="205" y="11" rx="2" ry="2" width="45" height="8" />
								<rect x="205" y="24" rx="2" ry="2" width="65" height="10" />
								<rect x="305" y="11" rx="2" ry="2" width="45" height="8" />
								<rect x="305" y="24" rx="2" ry="2" width="65" height="10" />
							</vcl>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div v-if="!loading">
	
					<v-row>
						<v-col cols="12" sm="6" md="3" class="flex-stretch justify-center">
							<v-layout column wrap>
								<v-flex
									style="flex:0; width: 100%"
									xs12
									align-self-end
								>
									<v-card class="px-4 py-3 mb-5 elevation-0 rounded-lg hover-shadow mitra-card" :class="networkType.classText">
										<template v-if="Object.values(myProfile).length > 0"><upgradedate-alert :myProfile="myProfile" :networkType="myProfile.network_type"></upgradedate-alert></template>
										<v-row class="align-center justify-center">
											<v-col cols="12" md="12" class="mt-1 text-center">
												<img class="img-fluid" width="100" style="height: auto;max-width: 100%;" :src="networkType.badges">
											</v-col>
											<v-col cols="12" md="12" class="pt-0 text-center">
												<div class="font-size-16 cl-secondary font-weight-600 text-uppercase" :style="'color:' + networkType.color">
													<div v-if="!myProfile.network_type">-</div>
													<div v-else>{{ (myProfile.network_type === 'gold') ? 'Gold Star' : (myProfile.network_type === 'repeat_order') ? 'Silver' : myProfile.network_type }}</div>
												</div>
												<div class="font-size-10 cl-grey">Kemitraan Anda saat ini</div>
											</v-col>
										</v-row>
									</v-card>
								</v-flex>

								<template v-if="myProfile.network_type !== 'diamond'">
									<v-row class="mb-1">
										<v-col cols="12" sm="12" class="pt-1">
												<v-btn
													color="primary"
													block
													@click="gotoUpgrade"
												><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade Kemitraan</v-btn>
										</v-col>
									</v-row>
								</template>

								<v-flex
									style="flex:1"
									xs12
								>
									<v-card class="px-4 py-4 elevation-0 rounded-lg hover-shadow fill-height">

										<div class="pt-1">
											<div class="font-size-10 cl-grey">Nama Pemilik</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-account-circle-outline</v-icon>
												<div class="font-size-11 cl-secondary font-weight-500">{{ myProfile.member_name }} ( <b>{{ myProfile.network_code }}</b> )</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Tanggal Daftar</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-calendar-range</v-icon>
												<div class="font-size-11 cl-secondary font-weight-500">{{ myProfile.member_join_datetime | tanggal }}</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Sponsor</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-account-multiple-outline</v-icon>
												<div class="font-size-11 cl-secondary font-weight-500">{{ myProfile.member_sponsor_network_code ? myProfile.member_sponsor_network_code : '-' }}</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Upline</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-account-network-outline</v-icon>
												<div class="font-size-11 cl-secondary font-weight-500">{{ myProfile.network_upline_network_code ? myProfile.network_upline_network_code : '-' }}</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Nama Bank</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-bank-outline</v-icon>
												<div class="font-size-11 cl-secondary font-weight-500">{{ myProfile.member_bank_name ? myProfile.member_bank_name : '-' }}</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Rekening</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-clipboard-account-outline</v-icon>
												<div class="font-size-11 cl-secondary font-weight-500">{{ myProfile.member_bank_account_no ? myProfile.member_bank_account_no : '-' }}</div>
											</div>
										</div>
									</v-card>
								</v-flex>
							</v-layout>
						</v-col>

						<v-col cols="12" sm="6" md="9">
							<v-row justify="center" class="mb-4">
								<v-col cols="12" sm="12" md="12" xl="12">
									<v-card class="elevation-0 rounded-lg pb-4">
										<v-card-title style="font-size: 18px!important;">
											Potensi Komisi Hari Ini
										</v-card-title>
										<div class="d-block px-5 pb-5">
											<v-row justify="start">
												<v-col cols="12" sm="12" md="4" class="pb-1" v-for="(komisi, idk) in listBonusToday" :key="idk">
													<v-card class="elevation-2 rounded-lg hover-shadow">
														<v-card-subtitle class="black--text lighten-3 font-weight-bold pb-1">{{ (komisi.label === 'Komisi Sponsor Repeat Order') ? 'Komisi Sponsor RO' : komisi.label }}</v-card-subtitle>
														<div class="d-block px-4 pb-4 font-size-14 green--text font-weight-600">{{ komisi.value | toRupiah }}</div>
													</v-card>
												</v-col>
											</v-row>
										</div>
									</v-card>
								</v-col>
							</v-row>
							
							<h3>Summary Komisi</h3>
							<v-row justify="center" class="my-2">
								<v-col cols="12" sm="12" md="4" xl="4">
									<v-card class="px-2 py-4 elevation-0 rounded-lg hover-shadow yellow darken-2">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right align-center">
												<img class="img-fluid img-darken" src="/assets/icon/total-bonus.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div class="font-size-14 white--text font-weight-600">{{ listSummaryBonus.totalAcc | toRupiah }}</div>
												<div class="font-size-10 gray--text darken-5">Total Diperoleh</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>

								<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3">
									<v-card class="px-2 py-4 elevation-0 rounded-lg hover-shadow green lighten-2">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
												<img class="img-fluid img-darken" src="/assets/icon/total-dibayarkan.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div class="font-size-14 white--text font-weight-600">{{ listSummaryBonus.totalPaid | toRupiah }}</div>
												<div class="font-size-10 gray--text darken-5">Total Dibayarkan</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>

								<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3">
									<v-card class="px-2 py-4 elevation-0 rounded-lg hover-shadow blue lighten-1">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
												<img class="img-fluid img-darken" src="/assets/icon/saldo.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div class="font-size-14 white--text font-weight-600">{{ listSummaryBonus.totalSaldo | toRupiah }}</div>
												<div class="font-size-10 gray--text darken-5">Total Saldo Komisi</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<template v-if="listSummaryBonus">
								<template v-for="(komisi, idx) in listSummaryBonus.arrKomisi">
									<v-card class="px-4 py-3 elevation-0 rounded-lg hover-shadow" :class="{'mt-3': (idx > 0)}" :key="idx">
										<v-row>
											<v-col cols="12" sm="12" md="4" class="my-auto flex-column mb-4 mb-md-0">
												<div class="font-size-9 cl-grey">Komisi</div>
												<div class="font-size-13 cl-secondary">{{ formatKomisiLabel(komisi.label) }}</div>
											</v-col>

											<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-none d-md-flex">
												<v-row>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
														<div class="font-size-10 cl-grey">Diperoleh</div>
														<div class="font-size-12 yellow--text text--darken-3 font-weight-500">{{ komisi.acc | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
														<div class="font-size-10 cl-grey">Dibayarkan</div>
														<div class="font-size-12 green--text font-weight-500">{{ komisi.paid | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
														<div class="font-size-10 cl-grey">Saldo</div>
														<div class="font-size-12 blue--text font-weight-500">{{ komisi.saldo | toRupiah }}</div>
													</v-col>
												</v-row>
											</v-col>

											<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-flex d-md-none">
												<v-row>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between">
														<div class="font-size-10 cl-grey">Diperoleh</div>
														<div class="font-size-10 yellow--text text--darken-3 font-weight-500">{{ komisi.acc | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between">
														<div class="font-size-10 cl-grey">Dibayarkan</div>
														<div class="font-size-10 green--text font-weight-500">{{ komisi.paid | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-4 my-auto d-flex align-center justify-space-between">
														<div class="font-size-10 cl-grey">Saldo</div>
														<div class="font-size-10 blue--text font-weight-500">{{ komisi.saldo | toRupiah }}</div>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card>
								</template>

								<template v-if="myProfile.network_id < 32732">
									<v-card class="px-4 py-3 elevation-0 rounded-lg hover-shadow mt-3">
										<v-row>
											<v-col cols="12" sm="12" md="4" class="my-auto flex-column mb-4 mb-md-0">
												<div class="font-size-9 cl-grey">Komisi</div>
												<div class="font-size-13 cl-secondary">Web Lama</div>
											</v-col>

											<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-none d-md-flex">
												<v-row>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
														<div class="font-size-10 cl-grey">Diperoleh</div>
														<div class="font-size-12 yellow--text text--darken-3 font-weight-500">{{ listSummaryBonus.totalOldAcc | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
														<div class="font-size-10 cl-grey">Dibayarkan</div>
														<div class="font-size-12 green--text font-weight-500">{{ listSummaryBonus.totalOldPaid | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
														<div class="font-size-10 cl-grey">Saldo</div>
														<div class="font-size-12 blue--text font-weight-500">{{ listSummaryBonus.totalOldSaldo | toRupiah }}</div>
													</v-col>
												</v-row>
											</v-col>

											<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-flex d-md-none">
												<v-row>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between">
														<div class="font-size-10 cl-grey">Diperoleh</div>
														<div class="font-size-10 yellow--text text--darken-3 font-weight-500">{{ listSummaryBonus.totalOldAcc | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between">
														<div class="font-size-10 cl-grey">Dibayarkan</div>
														<div class="font-size-10 green--text font-weight-500">{{ listSummaryBonus.totalOldPaid | toRupiah }}</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="pt-0 pb-4 my-auto d-flex align-center justify-space-between">
														<div class="font-size-10 cl-grey">Saldo</div>
														<div class="font-size-10 blue--text font-weight-500">{{ listSummaryBonus.totalOldSaldo | toRupiah }}</div>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card>
								</template>
							</template>

						</v-col>
					</v-row>
				</div>
			</v-scroll-x-reverse-transition>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import upgradeDateAlert from '@/components/upgradeDateAlert'

export default {
	components: {
		'upgradedate-alert': upgradeDateAlert
	},
	data() {
		return {
			loading: true,
			isActiveMember: false,
			networkType: null,
			kemitraan: [
				{
					type: 'pramitra',
					color: '#03bb5a',
					belanja: '0',
					badges: '',
					classText: 'mitra-pra'
				},
				{
					type: 'silver',
					color: '#688389',
					belanja: '1.300.000',
					badges: '/assets/icon/silver.svg',
					classText: 'mitra-silver'
				},
				{
					type: 'gold',
					color: '#6e490f',
					belanja: '3.900.000',
					badges: '/assets/icon/gold.svg',
					classText: 'mitra-gold'
				},
				{
					type: 'diamond',
					color: '#2a4fd6',
					belanja: '13.000.000',
					badges: '/assets/icon/diamond.svg',
					classText: 'mitra-diamond'
				}
			],
		}
	},
	computed: {
		...mapState('bonus', ['listSummaryBonus', 'summaryBonusPagination', 'listBonusToday']),
		...mapState('profile', ['myProfile']),
	},
	methods: {
		...mapActions('bonus', ['getSummaryBonus', 'getDetailBonusToday']),
		...mapActions('profile', ['getProfile', 'getProfileMitra', 'getProfilePramitra']),

		async getNetworkType(type) {
			if(type === 'repeat_order') type = await 'silver'
			this.networkType = this.kemitraan.find(x => x.type === type)
		},

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		showDetailUnilevel() {
			this.$refs.detailUnilevel.modalShow()
		},

		formatKomisiLabel(text) {
			if (text) {
				if (text === 'Komisi Sponsor Repeat Order') return 'Sponsor RO'
				else return text.replace('Komisi', '')
			} else {
				return '-'
			}
		},
		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},
		async getData() {
			this.loading = await true
			await this.getDetailBonusToday()
			await this.getSummaryBonus()

			if (this.isActiveMember) {
				await this.getProfile()
				await this.getNetworkType(this.myProfile.network_type)
			}
			this.loading = false
		},
	},
	async created(){
		this.$store.dispatch('setPageTitle', `Summary Komisi`)
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.checkMemberActivation(data)
		this.getData()
	}
};
</script>

